import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const classes = {
  noBorderListItem: css`
    ${cssTheme.default.day.line.token}: 0;
  `,
  noActionSelectItem: css`
    pointer-events: none;
  `,
  popper: css`
    // https://popper.js.org/docs/v2/modifiers/hide/
    &[data-popper-reference-hidden] {
      display: none;
    }
  `,
}
